import React, { useEffect, useRef, useState, useContext } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../Components/Card/Card";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";

import MarcasCRUD from "./MarcasCRUD/MarcasCRUD";
import { getMarcas } from "../../../../API/IT/MarcaProducto/MarcaProductoRequest";
import { setTitlePage } from "../../../Services/Config/ConfigService";

const MarcasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [marcas, setMarcas] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const marcas = await getMarcas();
    setMarcas(marcas);
    setLoading(false);
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdMarca",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Marca",
      headerEn: "Brand",
      field: "Marca",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "IdMarca",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: marcas,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "marcasDisp", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "marcasDisp", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <MarcasCRUD
          listMarcas={marcas}
          toastRef={toast}
          marcaDialog={showDialog}
          marca={selected}
          setMarcaDialog={setShowDialog}
          getPos={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default MarcasScreen;
